import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiCreateFreeeAuthForAccountingRequest,
  DefaultApiPostCallbackFreeeAuthForAccountingRequest,
  DefaultApiConnectFreeeForAccountingRequest,
  DefaultApiDisconnectFreeeForAccountingRequest,
  DefaultApiGetFreeeConnectionLinkedAccountForAccountingRequest,
  DefaultApiGetFreeeConnectionSettingsForAccountingRequest,
  DefaultApiUpdateFreeeConnectionSettingsForAccountingRequest,
  DefaultApiRequestSyncCardTransactionsToFreeeForAccountingRequest,
  DefaultApiRequestSyncBankTransactionsToFreeeForAccountingRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const createFreeeAuthForAccounting = async (
  instance: AxiosInstance,
  params: DefaultApiCreateFreeeAuthForAccountingRequest
) => {
  return await userApiDefaultApiFactory(instance).createFreeeAuthForAccounting(
    params
  )
}

export const postCallbackFreeeAuthForAccounting = async (
  instance: AxiosInstance,
  params: DefaultApiPostCallbackFreeeAuthForAccountingRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).postCallbackFreeeAuthForAccounting(params)
}
export const connectFreeeForAccounting = async (
  instance: AxiosInstance,
  params: DefaultApiConnectFreeeForAccountingRequest
) => {
  return await userApiDefaultApiFactory(instance).connectFreeeForAccounting(
    params
  )
}

export const disconnectFreeeForAccounting = async (
  instance: AxiosInstance,
  params: DefaultApiDisconnectFreeeForAccountingRequest
) => {
  return await userApiDefaultApiFactory(instance).disconnectFreeeForAccounting(
    params
  )
}

export const getFreeeConnectionLinkedAccountForAccounting = async (
  instance: AxiosInstance,
  params: DefaultApiGetFreeeConnectionLinkedAccountForAccountingRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getFreeeConnectionLinkedAccountForAccounting(params)
}

export const getFreeeConnectionSettingsForAccounting = async (
  instance: AxiosInstance,
  params: DefaultApiGetFreeeConnectionSettingsForAccountingRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getFreeeConnectionSettingsForAccounting(params)
}

export const updateFreeeConnectionSettingsForAccounting = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateFreeeConnectionSettingsForAccountingRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).updateFreeeConnectionSettingsForAccounting(params)
}

export const requestSyncCardTransactionsToFreeeForAccounting = async (
  instance: AxiosInstance,
  params: DefaultApiRequestSyncCardTransactionsToFreeeForAccountingRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).requestSyncCardTransactionsToFreeeForAccounting(params)
}

export const requestSyncBankTransactionsToFreeeForAccounting = async (
  instance: AxiosInstance,
  params: DefaultApiRequestSyncBankTransactionsToFreeeForAccountingRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).requestSyncBankTransactionsToFreeeForAccounting(params)
}

// Do Not Remove this line ===@import api client===
